import { useState } from "react";

import "./style.css"

function Gallery({ gallery, setGallery }) {
    const [counter, setCounter] = useState(0);

    const handleFile = (e, mod) => {
        const file = e.target.files[0];
        if (!file) return

        const url = URL.createObjectURL(file);

        e.target.value = '';

        let newImagesList = [...gallery];

        if (mod === 'add') newImagesList.push({ file, url });
        else newImagesList[counter] = { file, url };

        setGallery(prev => {
            return {
                ...prev,
                gallery: newImagesList
            }
        });

        const newCounter = mod === 'add' ? newImagesList.length - 1 : counter;
        setCounter(newCounter);
    }

    const deleteFile = (idx) => {
        if (gallery.length <= 1) return

        const newSlider = gallery.filter((s, id) => id !== idx);

        if (counter !== 0) {
            setCounter(counter - 1);
        }

        setGallery(prev => {
            return {
                ...prev,
                gallery: newSlider
            }
        })
    }

    const switchLeft = (idx) => {
        if (idx === 0) return;

        const newList = [...gallery];
        [newList[idx - 1], newList[idx]] = [newList[idx], newList[idx - 1]];
        
        setGallery(prev => ({ 
            ...prev, 
            gallery: newList 
        }));
    };

    const switchRight = (idx) => {
        if (idx === gallery.length - 1) return;

        const newList = [...gallery];
        [newList[idx], newList[idx + 1]] = [newList[idx + 1], newList[idx]];
        
        setGallery(prev => ({ 
            ...prev, 
            gallery: newList 
        }));
    };

    return gallery && (
        <div className='gallery'>
            <div className="view">
                {gallery[counter] && <i style={{ backgroundImage: `url(${gallery[counter].url})` }}></i>}
                <input type="file" onChange={(e) => handleFile(e)} />
                {!gallery[counter] && <span>Ajouter une image</span>}
            </div>

            <div className="panel_gallery">
                {gallery.map((img, idx) => (

                    <div key={idx} className="slide">
                        {idx !== 0 &&
                            <button
                                className="del_slide btn_panel"
                                onClick={() => deleteFile(idx)}
                            ><i className="fas fa-xmark"></i></button>
                        }

                        {idx !== gallery.length - 1 &&
                            <button
                                className="btn_right btn_panel"
                                onClick={() => switchRight(idx)}
                            ><i className="fas fa-chevron-right"></i></button>
                        }

                        {idx !== 0 &&
                            <button
                                className="btn_left btn_panel"
                                onClick={() => switchLeft(idx)}
                            ><i className="fas fa-chevron-left"></i></button>
                        }

                        <button
                            className="btn_slide"
                            onClick={() => setCounter(idx)}
                            style={{ backgroundImage: `url(${img.url})` }}
                        ></button>
                    </div>
                ))}

                <button className="btn_add">
                    <i className="fas fa-plus"></i>
                    <input type="file" onChange={(e) => handleFile(e, 'add')} />
                </button>
            </div>
        </div>
    )
}

export default Gallery;